import SuggestNewCarrierFeedback from './SuggestNewCarrierFeedback'
import PackageTimeline from './PackageTimeline'
import React from 'react'
import { deepCompare, notifyAndLog } from '../../../libraries/utils'
import { useTranslation } from 'react-i18next'
import PackageModel from '@geartrack/shared-lib/dist/PackageModel'
import useCarriersForTrackingId from '../../../hooks/useCarriersForTrackingId'

type Props = {
  pkg: PackageModel
  setLoading: React.Dispatch<boolean>
}

const PackageInformationBody = ({ pkg, setLoading }: Props) => {
  const { t } = useTranslation('packages')
  const { data, error } = useCarriersForTrackingId(pkg.trackingId)

  if (error) {
    setLoading(false)
    notifyAndLog(error)
    return <div>{t('timeline.error-fetching-data')}</div>
  }

  if (!data) {
    return (
      <div>
        <i className="fas fa-spin fa-circle-notch" /> {t('timeline.detecting compatible')}
      </div>
    )
  }

  if (data.carriers.length === 0) {
    setLoading(false)
    return <SuggestNewCarrierFeedback message={t('timeline.no compatible carrier')} pkg={pkg} />
  }

  return <PackageTimeline pkg={pkg} carriersListResponse={data} setLoading={setLoading} />
}

export default React.memo(PackageInformationBody, deepCompare)
